"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aclActions = void 0;
var aclActions;
(function (aclActions) {
    aclActions["read"] = "role_read";
    aclActions["write"] = "role_write";
    aclActions["delete"] = "role_delete";
})(aclActions || (exports.aclActions = aclActions = {}));
